import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';

const RECEIVE = 'subcampaignPayments/RECEIVE';
const RESET = 'subcampaignPayments/RESET';

const initialState = {
  payments: null
};

export function resetSubcampaignPayments() {
  return {
    type: RESET,
    payload: {}
  };
}

function receiveSubcampaignPayments(data) {
  return {
    type: RECEIVE,
    payload: {
      data
    }
  };
}

export function fetchSubcampaignPayments(subcampaignId) {
  const url = API.END_POINTS.API.getSubcampaignPayments(subcampaignId);

  return (dispatch) => {
    dispatch(showLoading(url));

    return get(url)
      .then((response) => {
        dispatch(receiveSubcampaignPayments(response.data));
        dispatch(hideLoading(url));
      })
      .catch(() => dispatch(hideLoading(url)));
  };
}

export default createReducer('subcampaignPayments', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [RECEIVE]: (state, { data }) => ({
    ...state,
    payments: data
  })
});
